import { FaIcon, faNoteSolid } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'

const CalendarDayInfoHeader = ({ date,setIsOpenNoteModal,isNoteExisting}) => {
  const {t} = useLocalize()
  return (
    <div className="tw-flex tw-z-[90] tw-w-full tw-items-center tw-justify-between tw-px-2.5 tw-py-2">
      <span className="tw-text-base tw-font-semibold tw-text-content-base">
        {date.format('YYYY-MM-DD')}
      </span>
      <div onClick={() => setIsOpenNoteModal(true)} className='tw-cursor-pointer tw-p-2 hover:tw-bg-base-200 tw-rounded-lg'>
        <FaIcon icon={faNoteSolid} className="tw-text-primary" />
        <span className="tw-text-sm tw-text-primary">
          {isNoteExisting ? t('notes.edit-note') : t('notes.add-note')}
          </span>
      </div>
    </div>
  )
}

export default CalendarDayInfoHeader
